$(function () {

    const body = $('body');

    body.addClass('is-loaded');

});

function scrolling() {
}

function resizing() {
}

$(window).on("load", function () {
});

$(document).on('scroll', scrolling);
$(window).resize(resizing);